import { ThemeOptions } from '@mui/material/styles/createTheme';
import { AutocompleteProps } from '@mui/material/Autocomplete';

const style = {
  height: 'auto',
  width: '100%',
  maxHeight: '160px',
  borderStyle: 'solid',
  boxSizing: 'border-box',
  overflow: 'auto',
  '&::-webkit-scrollbar': {
    width: '1rem',
    padding: '1rem',
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: '1rem',
  },
  '& .MuiInputBase-root': {
    padding: '10px 12px',
    '& .MuiInputBase-input': {
      padding: 0,
      minHeight: '24px !important',
      lineHeight: '24px !important',
    },
  },
  '.MuiTextField-root': {
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '.MuiFormHelperText-root': {
      margin: 0,
      marginTop: 1,
      fontSize: '14px',
      height: '20px',
    },
  },
  '.MuiChip-root': {
    height: '3rem',
    padding: 0,
    margin: '.5rem .5rem .5rem 0 !important',
    '.MuiChip-deleteIcon': {
      fontSize: '1rem',
      marginRight: '.625rem',
    },
    '.MuiChip-label': {
      maxWidth: '360px',
      fontSize: '.75rem',
      fontWeight: 600,
      textOverflow: 'ellipsis',
    },
  },
} as Record<string, any>;

export const MuiAutocompleteStyle = {
  styleOverrides: {
    root: ({
      theme,
      ownerState,
    }: {
      theme: ThemeOptions;
      ownerState: AutocompleteProps<any, any, any, any>;
    }) => {
      const ownerStateColor = ownerState?.color || 'inherit';
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const palletColor = theme.palette[ownerStateColor];
      return {
        ...style,
        borderRadius: theme?.shape?.borderRadius ?? '4px',
        borderColor: palletColor?.main ?? '#252A2E',
        borderWidth: ownerStateColor === 'error' ? '2px' : '1px',
        '&&::-webkit-scrollbar-thumb': {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          backgroundColor: theme.palette?.neutralGray6?.main ?? '#6A6E79',
          border: `4px solid ${theme.palette?.background?.paper ?? '#FFF'}`,
        },
        '&.Mui-focused': {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          border: `2px solid ${theme?.palette?.primary?.main ?? '#0063A3'}`,
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          outline: `2px solid ${theme?.palette?.secondary2?.main ?? '#252A2E'}`,
          outlineOffset: '2px',
        },
      };
    },
  },
};
